export default __webpack_public_path__ + "static/media/161.b0ad413c.png";